import BreadCrumbItem from '@/app/shared/models/BreadCrumbItem'

export const NAMESPACE = 'breadCrumb/'

const _types = {
  getters: {
    LAST_ITEM: 'LAST_ITEM',
    DIMENSION_IDS_IN_BREADCRUMB: 'DIMENSION_IDS_IN_BREADCRUMB',
    DIMENSION_IDS_IN_FILTERS: 'DIMENSION_IDS_IN_FILTERS',
    DIMENSION_TO_FILTER: 'DIMENSION_TO_FILTER',
    FIRST_ITEM: 'FIRST_ITEM'
  },
  actions: {
  },
  mutations: {
    RESET: 'RESET',
    PUSH_ITEM: 'PUSH_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM'
  }
}

export const Types = _types

const BreadCrumb = {
  namespaced: true,
  state: () => ({
    items: []
  }),
  getters: {
    [_types.getters.DIMENSION_IDS_IN_BREADCRUMB]: (state) => {
      return state.items.map((item) => item.dimension.id)
    },
    [_types.getters.LAST_ITEM]: (state) => {
      return state.items.length > 0 ? state.items[state.items.length - 1] : {}
    },
    [_types.getters.FIRST_ITEM]: (state) => {
      return state.items.length > 0 ? state.items[0] : {}
    },
    [_types.getters.DIMENSION_TO_FILTER]: (state, getters) => {
      return getters[_types.getters.LAST_ITEM].dimension
    },
    [_types.getters.FILTERS]: (state) => {
      return state.items.filter((item) => item.filter)
        .map((item) => item.filter)
    },
    [_types.getters.DIMENSION_IDS_IN_FILTERS]: (state, getters) => {
      return getters[_types.getters.FILTERS].map((filterItem) => filterItem.keyField)
    }
  },
  actions: {
  },
  mutations: {
    [_types.mutations.PUSH_ITEM] (state, { dimension, filter, text }) {
      const breadCrumbItem = new BreadCrumbItem({ dimension, filter, text: text })
      state.items.push(breadCrumbItem)
    },
    [_types.mutations.REMOVE_ITEM] (state, item) {
      const itemIndex = state.items.indexOf(item)
      state.items.splice(itemIndex, 1)
    },
    [_types.mutations.RESET] (state) {
      state.items = []
    }
  },
  modules: {
  }
}

export default BreadCrumb



// WEBPACK FOOTER //
// ./src/app/shared/store/modules/BreadCrumb.js